import { Textarea as BaseTextarea } from "../ui/textarea";

/**
 * Inserts a literal tab character when Tab is pressed inside a textarea
 * (instead of moving focus). Extracted verbatim from ProgramBuilder.js.
 */
export function handleTextareaTabKeyDown(event) {
	if (
		event.key !== "Tab" ||
		event.shiftKey ||
		event.altKey ||
		event.ctrlKey ||
		event.metaKey
	) {
		return;
	}

	const target = event.target;
	if (!(target instanceof HTMLTextAreaElement)) {
		return;
	}

	event.preventDefault();

	const { selectionStart, selectionEnd, value } = target;

	if (selectionStart === selectionEnd) {
		const nextValue =
			value.slice(0, selectionStart) + "\t" + value.slice(selectionEnd);
		target.value = nextValue;
		const nextCursorPosition = selectionStart + 1;
		target.setSelectionRange(nextCursorPosition, nextCursorPosition);
		target.dispatchEvent(new Event("input", { bubbles: true }));
		return;
	}

	const startLineIndex = value.lastIndexOf("\n", selectionStart - 1) + 1;
	const selectedBlock = value.slice(startLineIndex, selectionEnd);
	const selectedLineCount = selectedBlock.split("\n").length;
	const indentedBlock = "\t" + selectedBlock.replace(/\n/g, "\n\t");
	const nextValue =
		value.slice(0, startLineIndex) + indentedBlock + value.slice(selectionEnd);

	target.value = nextValue;
	const nextSelectionStart = selectionStart + 1;
	const nextSelectionEnd = selectionEnd + selectedLineCount;
	target.setSelectionRange(nextSelectionStart, nextSelectionEnd);
	target.dispatchEvent(new Event("input", { bubbles: true }));
}

/**
 * Textarea wrapper used across ProgramBuilder forms. Adds tab-to-insert-tab
 * behavior and forwards a `textareaRef`. Behavior identical to the original
 * inline wrapper in ProgramBuilder.js.
 */
export function Textarea({ onKeyDown, textareaRef, ...props }) {
	return (
		<BaseTextarea
			{...props}
			ref={textareaRef}
			onKeyDown={(event) => {
				handleTextareaTabKeyDown(event);
				onKeyDown?.(event);
			}}
		/>
	);
}
